import accountService from "./../../services/account";
import bookingService from "./../../services/booking";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import mixin from "../../mixins/mixin";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import Vue from "vue";

export default {
  data() {
    return {
      en: en,
      fr: fr,
      language: localStorage.getItem("lang") || "fr",
      windowWidth: window.innerWidth,
      isSlideMultiple: true,
      selectedImage: {},
      rental: [],
      startDate: {},
      endDate: {},
      diffDays: 1,
      bookingDetails: {
        bookingDate: [
          moment().format("YYYY-MM-DD"),
          moment().add(1, "days").format("YYYY-MM-DD"),
        ],
        bookingDateNotAfter: moment().add(90, "days"),
        bookingDateNotBefore: moment(),
        isAvailableBooking: "",
        duration: "",
        pricePerNight: "",
        adultsCount: this.$route.query.adultsNumber || 0,
        childrenCount: this.$route.query.childrenNumber || 0,
        cityTaxes: 0,
        price: "",
      },
      bigImages: [],
      defaultImages: [],
      imageIndex: 0,
      checkAvailability: {
        startDate: this.$route.query.startDate || "",
        endDate: this.$route.query.endDate || "",
        adultsCount: this.$route.query.adultsNumber || 0,
        childrenCount: this.$route.query.childrenNumber || 0,
      },
      images: [
        {
          id: 1,
          src: "https://res.cloudinary.com/sonder/image/private/s--4SjuJciF--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/702/original/iOGsTLAC.jpg",
        },
        {
          id: 2,
          src: "https://res.cloudinary.com/sonder/image/private/s--gGzZW5A1--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/720/original/I2kVtyEi.jpg",
        },
        {
          id: 3,
          src: "https://res.cloudinary.com/sonder/image/private/s--CgQRwz5e--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/703/original/2nEV9vxQ.jpg",
        },
        {
          id: 4,
          src: "https://res.cloudinary.com/sonder/image/private/s--089jVPsY--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/705/original/64vMh56-.jpg",
        },
        {
          id: 5,
          src: "https://res.cloudinary.com/sonder/image/private/s--E4cb3HJj--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/704/original/a2HwPMLp.jpg",
        },
        {
          id: 6,
          src: "https://res.cloudinary.com/sonder/image/private/s--oHTxyxHJ--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/708/original/dnnQoedL.jpg",
        },
        {
          id: 7,
          src: "https://res.cloudinary.com/sonder/image/private/s--Nx72rcD6--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/706/original/3PPQcot5.jpg",
        },
        {
          id: 8,
          src: "https://res.cloudinary.com/sonder/image/private/s--oA7q-DM_--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/707/original/ZAPUCtRb.jpg",
        },
        {
          id: 9,
          src: "https://res.cloudinary.com/sonder/image/private/s--BTxeko3u--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/711/original/nDObknHH.jpg",
        },
        {
          id: 10,
          src: "https://res.cloudinary.com/sonder/image/private/s--b2jn_UXN--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/710/original/4hc1W7Mj.jpg",
        },
        {
          id: 11,
          src: "https://res.cloudinary.com/sonder/image/private/s--Zwu5eo9E--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/721/original/mKHUNXWZ.jpg",
        },
        {
          id: 12,
          src: "https://res.cloudinary.com/sonder/image/private/s--qrb7Q8g1--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/729/original/7paLRLX5.jpg",
        },
        {
          id: 13,
          src: "https://res.cloudinary.com/sonder/image/private/s--QAOZ81mE--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/718/original/3qIgttwI.jpg",
        },
        {
          id: 14,
          src: "https://res.cloudinary.com/sonder/image/private/s--y58i7Ppb--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/714/original/cTvEq3c3.jpg",
        },
        {
          id: 15,
          src: "https://res.cloudinary.com/sonder/image/private/s--BSWNUFTv--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/716/original/Noew7515.jpg",
        },
        {
          id: 16,
          src: "https://res.cloudinary.com/sonder/image/private/s--tBr2irBd--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/719/original/w219oSCh.jpg",
        },
        {
          id: 17,
          src: "https://res.cloudinary.com/sonder/image/private/s--f2n3ngpx--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/722/original/kcmARzVz.jpg",
        },
        {
          id: 18,
          src: "https://res.cloudinary.com/sonder/image/private/s---7uNgH2n--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/723/original/2X3jOqbI.jpg",
        },
        {
          id: 19,
          src: "https://res.cloudinary.com/sonder/image/private/s---7uNgH2n--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/723/original/2X3jOqbI.jpg",
        },
        {
          id: 20,
          src: "https://res.cloudinary.com/sonder/image/private/s--L-9fjgG9--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/726/original/tsWp8GOI.jpg",
        },
        {
          id: 21,
          src: "https://res.cloudinary.com/sonder/image/private/s--4D2e_P0L--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/727/original/2myprQuo.jpg",
        },
        {
          id: 22,
          src: "https://res.cloudinary.com/sonder/image/private/s---tgl901q--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/149/699/original/waS_o0EU.jpg",
        },
        {
          id: 23,
          src: "https://res.cloudinary.com/sonder/image/private/s--JfCFloaI--/c_fill,f_auto,q_auto:eco,w_2000/v1/s3assets/unit_images/images/000/175/639/original/dc_QS59b.jpg",
        },
      ],
      slides: [
        {
          title: "Slide #1",
          content: "Slide content.",
        },
      ],
      notAvailableDates: [],
      highlightedDates: [],
      loading: true,
      lang: this.$route.query.lang || "fr",
      includeOverrideMsg: "",
    };
  },
  components: {
    Datepicker,
    VueperSlides,
    VueperSlide,
    VBookingCheckout: require("./checkout.vue"),
    VLoading: require("components/loading/loading.vue"),
  },
  mixins: [mixin],
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });

    if (!this.$route.query.adultsNumber) {
      this.bookingDetails.adultsCount =
        this.$route.query.guestNumber > 0 ? this.$route.query.guestNumber : 1;
    } else {
      this.bookingDetails.adultsCount =
        this.bookingDetails.adultsCount > 0
          ? this.bookingDetails.adultsCount
          : 1;
    }
    this.bookingDetails.childrenCount =
      this.bookingDetails.childrenCount > 0
        ? this.bookingDetails.childrenCount
        : 0;
    Vue.config.lang = this.lang;

    await accountService.getRentalInfo(this, this.$route.params.propertyKey);
    if (this.rental.user_web && this.rental.user_web.slider_images.length) {
      const images = [];
      this.rental.user_web.slider_images.forEach((im) =>
        images.push({ id: im.id, src: im.url })
      );
      this.defaultImages = images;
    } else {
      this.defaultImages = [...this.images];
    }
    if (this.checkAvailability.startDate && this.checkAvailability.endDate) {
      this.checkAvailableBookings(
        this.checkAvailability.startDate,
        this.checkAvailability.endDate,
        this.checkAvailability.adultsCount,
        this.checkAvailability.childrenCount
      );
    }

    if (this.rental.web_settings) {
      if (
        this.rental.user_web &&
        this.rental.user_web[`description_${this.lang}`]
      ) {
        this.rental.user_web.description = this.rental.user_web[
          `description_${this.lang}`
        ].replace("<p>​</p>", "");
      }
      if (this.rental.user_web && this.rental.user_web[`note_${this.lang}`]) {
        this.rental.user_web.note = this.rental.user_web[
          `note_${this.lang}`
        ].replace("<p>​</p>", "");
      }
      if (this.rental.user_web && this.rental.user_web[`cgv_${this.lang}`]) {
        this.rental.user_web.cgv = this.rental.user_web[
          `cgv_${this.lang}`
        ].replace("<p>​</p>", "");
      }

      if (
        this.rental.user_web &&
        this.rental.user_web[`error_title_${this.lang}`]
      ) {
        this.rental.user_web.error_title =
          this.rental.user_web[`error_title_${this.lang}`];
      }

      if (
        this.rental.user_web &&
        this.rental.user_web[`error_description_${this.lang}`]
      ) {
        this.rental.user_web.error_description =
          this.rental.user_web[`error_description_${this.lang}`];
      }

      if (this.rental.web_settings.google_pixel_head) {
        const text = this.rental.web_settings.google_pixel_head.match(
          /<script>([\s\S]*?)<\/script>/
        );

        const head = document.getElementsByTagName("head")[0];
        const script = document.createElement("script");
        if (text) {
          script.innerText = text[1];

          head.appendChild(script);
        }
      }

      if (this.rental.web_settings.google_pixel_body) {
        const text = this.rental.web_settings.google_pixel_body.match(
          /<script>([\s\S]*?)<\/script>/
        );
        const body = document.getElementsByTagName("body")[0];
        const script = document.createElement("script");
        if (text) {
          script.innerText = text[1];
          body.appendChild(script);
        }
      }

      if (this.rental.web_settings.custom_style) {
        const customStyleHead = document.getElementsByTagName("head")[0];
        let customStyle = document.createElement("style");
        customStyle.type = "text/css";
        customStyle.innerText = this.rental.web_settings.custom_style;
        customStyleHead.appendChild(customStyle);
      }
    }

    await this.getNotAvailableDates(this.rental.id);
    moment.locale("fr");
    Vue.config.lang = this.lang;
    this.loading = false;
  },
  watch: {
    windowWidth(newWidth) {
      if (newWidth >= 992) {
        this.closeModal("#booking-engine-modal");
      }
    },
    "checkAvailability.startDate": function (newCheckinDate, oldCheckinDate) {
      const sameDay =
        this.checkAvailability.endDate &&
        moment(newCheckinDate).isSame(this.checkAvailability.endDate, "day");
      const beforeCheckin =
        this.checkAvailability.endDate &&
        moment(this.checkAvailability.endDate).isBefore(newCheckinDate, "day");

      if (
        (oldCheckinDate === "" && this.checkAvailability.endDate === "") ||
        sameDay ||
        beforeCheckin
      ) {
        const newCheckoutDate = new Date(newCheckinDate);
        newCheckoutDate.setDate(newCheckoutDate.getDate() + 1);
        this.checkAvailability.endDate = newCheckoutDate;
      }
      this.checkAvailableBookings(
        this.checkAvailability.startDate,
        this.checkAvailability.endDate
      );
      this.getNotAvailableDates(this.rental.id);
      this.correctDatePickerDates(newCheckinDate);
    },
    "checkAvailability.endDate": function (newCheckoutDate) {
      this.checkAvailableBookings(
        this.checkAvailability.startDate,
        this.checkAvailability.endDate
      );
      this.getNotAvailableDates(this.rental.id);
      this.correctDatePickerDates(newCheckoutDate, "end");
    },
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    checkAvailableBookings(start, end) {
      const data = {
        start_date:
          start === ""
            ? null
            : moment.utc(start, "YYYY-MM-DD").format("Y-MM-DD"),
        end_date:
          end === "" ? null : moment.utc(end, "YYYY-MM-DD").format("Y-MM-DD"),
        id: this.rental.id,
        nbr_adults: this.bookingDetails.adultsCount,
        nbr_children: this.bookingDetails.childrenCount,
        lang: this.lang,
      };

      bookingService.checkBookingAvailability(this, data);
    },
    makeBooking() {
      if (this.rental.user_web.mail_request_enabled) {
        window.location.href =
          "mailto:" +
          this.rental.user.email +
          "?subject=Demande de réservation pour " +
          this.rental.name +
          "&body=" +
          encodeURIComponent(
            "Arrivée : " +
              moment(this.checkAvailability.startDate, "YYYY-MM-DD").format(
                "Y-MM-DD"
              ) +
              "\nDépart : " +
              moment(this.checkAvailability.endDate, "YYYY-MM-DD").format(
                "Y-MM-DD"
              ) +
              "\nAdultes : " +
              this.bookingDetails.adultsCount +
              "\nEnfants : " +
              this.bookingDetails.childrenCount +
              "\n" +
              this.bookingDetails.price /
                parseInt(this.bookingDetails.duration) +
              this.rental.currency.symbol +
              " x " +
              this.bookingDetails.duration +
              " nuit" +
              (this.bookingDetails.duration > 1 ? "s" : "") +
              " : " +
              this.bookingDetails.price +
              this.rental.currency.symbol +
              "\nFrais de Ménage : " +
              this.rental.cleaning +
              this.rental.currency.symbol +
              "\nTaxe de séjour  : " +
              this.bookingDetails.cityTaxes +
              this.rental.currency.symbol +
              "\nTotal : " +
              (this.bookingDetails.price +
                parseFloat(this.rental.cleaning) +
                parseFloat(this.bookingDetails.cityTaxes)) +
              this.rental.currency.symbol +
              "\n" +
              "\nMerci d'indiquer vos informations : " +
              "\nNom : " +
              "\nPrénom : " +
              "\nTéléphone : " +
              "\nEmail : "
          );
      } else {
        this.closeModal("#booking-engine-modal");
        if (this.bookingDetails.isAvailableBooking === "available") {
          Vue.router.push({
            name: "booking.create",
            params: {
              propertyKey: this.rental.property_key,
            },
            query: {
              checkin: moment(
                this.checkAvailability.startDate,
                "YYYY-MM-DD"
              ).format("Y-MM-DD"),
              checkout: moment(
                this.checkAvailability.endDate,
                "YYYY-MM-DD"
              ).format("Y-MM-DD"),
              adultsCount: this.bookingDetails.adultsCount,
              childrenCount: this.bookingDetails.childrenCount,
              // duration: this.bookingDetails.duration,
              // price: this.bookingDetails.price,
              // tax: this.bookingDetails.cityTaxes,
              lang: this.lang,
            },
          });
        }
      }
    },
    incOrDecGuestCount(sign, isChild = false) {
      if (sign === "+") {
        if (isChild) {
          this.bookingDetails.childrenCount++;
        } else {
          this.bookingDetails.adultsCount++;
        }
      } else {
        if (isChild) {
          if (this.bookingDetails.childrenCount === 0) {
            return;
          }
          this.bookingDetails.childrenCount--;
        } else {
          if (this.bookingDetails.adultsCount === 1) {
            return;
          }
          this.bookingDetails.adultsCount--;
        }
      }
      if (
        this.checkAvailability.startDate === "" ||
        this.checkAvailability.endDate === ""
      ) {
        toastr.error("Please select start date or end date");
        return;
      }
      this.checkAvailableBookings(
        this.checkAvailability.startDate,
        this.checkAvailability.endDate
      );
    },
    showImageModal(image = {}, index = 1) {
      this.isSlideMultiple = true;
      this.imageIndex = index;

      if (this.isSlideMultiple) {
        const defaultImagesCopy = [...this.defaultImages];
        this.bigImages = [
          ...defaultImagesCopy.slice(index),
          ...defaultImagesCopy.slice(0, index),
        ];
      }
      if (image) {
        this.selectedImage = image;
      }
    },
    closeImageModal() {
      this.bigImages = [];
    },
    fullScreenSlider() {
      this.isSlideMultiple = !this.isSlideMultiple;
    },
    async getNotAvailableDates(rentalId) {
      await bookingService.getNotAvailableDates({ rentalId }, this);
    },
    getNotAvailableDatesRange() {
      const dates = { ...this.notAvailableDates };

      this.startDate.highlighted = {
        dates: this.getDatesNotAvailable(dates, "checking"),
      };
      this.endDate.highlighted = {
        dates: this.getDatesNotAvailable(dates, "checkout"),
      };

      this.$forceUpdate();
    },
    correctDatePickerDates(newDate, type = "start") {
      if (this.checkAvailability.startDate >= this.checkAvailability.endDate) {
        if (type === "start") {
          this.checkAvailability.endDate = moment(newDate)
            .add(this.diffDays, "days")
            .format("YYYY-MM-DD");
        } else {
          this.checkAvailability.startDate = moment(newDate)
            .subtract(this.diffDays, "days")
            .format("YYYY-MM-DD");
        }
      } else {
        this.diffDays = moment(this.checkAvailability.endDate).diff(
          moment(this.checkAvailability.startDate),
          "days"
        );
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/external-availability/detail.js